package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class Cart(
    @SerialName("id") val id: String,
    @SerialName("createdAt") val createdAt: String,
    @SerialName("lastModified") val lastModified: String,
    @SerialName("cartState") val cartState: String,
    @SerialName("subtotal") val subtotal: Double,
    @SerialName("savings") val savings: Double,
    @SerialName("total") val total: Double,
    @SerialName("discount") val discount: Int,
    @SerialName("promo") val promo: Int,
    @SerialName("shipping") val shipping: Double,
    @SerialName("tax") val tax: Double,
    @SerialName("recyclingFee") val recyclingFee: Double,
    @SerialName("grandTotal") val grandTotal: Double,
    @SerialName("totalSavings") val totalSavings: Double,
    @SerialName("discountCodes") val discountCodes: List<Discount>,
    @SerialName("lineItems") val lineItems: List<CartItem.CartLineItem>,
    @SerialName("customer") val customer: CartProfile? = null,
)

@Serializable
@JsExport
data class CartProfile(
    @SerialName("email") val email: String?,
    @SerialName("shippingAddress") val shippingAddress: CartAddress?,
    @SerialName("billingAddress") val billingAddress: CartAddress?,
)
